import baseStyled, { css as baseCss, ThemedCssFunction, ThemedStyledInterface } from 'styled-components';

import { UsersPageTheme } from './themes/types';

const styled = baseStyled as ThemedStyledInterface<UsersPageTheme>;
const css = baseCss as ThemedCssFunction<UsersPageTheme>;

export const UsersPage = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
`;

export const TableContainer = styled.div`
  flex: 1;
  overflow: hidden;
  padding: 8px;
  margin-top: 8px;
  box-sizing: border-box;
`;
